import { Header } from "../App/Header";
import { Footer } from "../App/Footer";
import { Homepage } from "./Homepage";
import { Map } from "./Map";
import { usePageContentContext } from "../../contexts/PageContentProvider";
import { Ciris } from "./Ciris";
import { styled } from "styled-components";
import { EnablingServices } from "./EnablingServices";
import { EnergeticCertificate } from "./EnergeticCertificate";
import { Events } from "./Events";
import { RegisterDetail } from "./RegisterDetail";
import { Register } from "./Register";
import { Analytic } from "./Analytic";
import { useGlobalFilterContext } from "../../contexts/GlobalFilterProvider";
import { useTranslation } from 'react-i18next';
import i18next from "i18next";
import { useEffect, useState } from "react";
import useFetch from "../../server/useFetch";
import query, { apiKey } from "../../server/constants.api";
import { Filters } from "../App/Filter/Filters";
import { Access } from "../Global/Molecules/Configurations/Access";
//#region  Styled Components
//Where we define the styles, CSS and other aspects for the page components
const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow-y: clip;
`;

const MainContent = styled.div`
    display: flex;
    height: calc(100% - 88px);
    /* overflow: hidden; */
    /* flex-direction: column; */
    /* min-height: 100vh - 93px; */
`;

const RightContent = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    /* justify-content: space-between; */
    width: 100%;
    overflow-y: auto;
    height: 100%;
    justify-content: space-between;
`;

const FiltersContainer = styled.div`
    display: block;
    z-index: 1;
`;
//#endregion
export function Home() {
    const [userTenant] = useState(localStorage.getItem(`adeporto_tenant`));
    const { data: entitiesData, isLoading: entitiesIsLoading, refetch: refetchEntities } = useFetch(query.path.entinties, 'getEntitiesForFilters', { tenant: userTenant });
    const [zones, setZones] = useState([]);
    const [name, setName] = useState(null);
    const { sideBarMenu, withFilters, currentPath } = usePageContentContext();
    // const { applyFilters, resetFilters } = useMapContext();
    const { changeGlobalFilterContent, enableApplyButton } = useGlobalFilterContext();
    const { t } = useTranslation();
    const filtersTranslate =
    {
        filters: t('filters'),
        apply: t('apply'),
        clear: t('clear'),
    }

    useEffect(() => {
        try {
            const localStorageZones = localStorage.getItem(`adeporto_zones`);
            if (localStorageZones !== 'undefined') {
                const localStorageZonesParse = JSON.parse(localStorageZones);
                setZones(localStorageZonesParse);
            }
        } catch (error) {
            // logger.error('Error in useEffect checking localStorageZones');
            console.error('(Home page) Error in useEffect checking localStorageZones:', error);
            //reportError(error); // Send error report to backend
        }
    }, [])

    useEffect(() => {
        if(entitiesData?.data && entitiesData?.data.length > 0) {
            const orderEntities = entitiesData?.data.sort((a, b) => {
                const labelA = a.Entity.name.toUpperCase(); // Ignore maiúsculas e minúsculas
                const labelB = b.Entity.name.toUpperCase(); // Ignore maiúsculas e minúsculas
            
                if (labelA < labelB) {
                    return -1;
                }
                if (labelA > labelB) {
                    return 1;
                }
            
                // labels são iguais
                return 0;
            });

            const entity = orderEntities?.[0]?.Entity.name.split('.');
            setName(entity[0]);
        }
    }, [entitiesData])

    function renderPage(currentPath) {
        try {

            if (currentPath) {
                if (currentPath?.includes('/home/map') && zones?.includes('map')) {
                    // logger.info('User went to home/map');
                    // setIsToApplyFilters(true);
                    return <Map city={name} />;
                } else if (currentPath?.includes('/home/politics/CIRIS') && zones?.includes('policies')) {
                    // logger.info('User went to home/politics/CIRIS');
                    return <Ciris />;
                } else if (currentPath?.includes('enabling services')) {
                    // logger.info('User went to enabling services');
                    return <EnablingServices />;
                } else if (currentPath?.includes('/home/politics/energeticCertficate')) {
                    // logger.info('User went to home/politics/energeticCertificate');
                    return <EnergeticCertificate />;
                } else if (currentPath?.includes('/home/events') && zones?.includes('events')) {
                    // logger.info('User went to home/events');
                    // setIsToApplyFilters(true);
                    return <Events />;
                } else if (currentPath?.includes('/register/registerDetail')) {
                    // logger.info('User went to register/registerDetail');
                    return <RegisterDetail />;
                } else if (currentPath?.includes('/register') && zones?.includes('registry')) {
                    // logger.info('User went to register/register');
                    return <Register />;
                } else if (currentPath?.includes('/analitics') && zones?.includes('analytics')) {
                    // logger.info('User went to analitics');
                    return <Analytic />;
                } else if (currentPath?.includes('/home/configurations/access') && zones?.includes('configurations')) {
                    // logger.info('User went to home/configurations/access');
                    return <Access />;
                } else {
                    // logger.info('User went to Homepage');
                    return <Homepage />;
                }
            }
        } catch (error) {
            // logger.error('Error in rendering Page currenntPath');
            console.error('(Home page) Error in rendering Page currenntPath:', error);
            //reportError(error); // Send error report to backend
        }
    }

    function onApplyFilter(contentFilter) {
        try {
            changeGlobalFilterContent(contentFilter);
            setName(contentFilter.name)
        } catch (error) {
            console.error('(Home page) Error in onApplyFilter function:', error);
            //reportError(error); // Send error report to backend
        }
    }

    function onResetFilters() {
        try {

            // resetFilters();
        } catch (error) {
            console.error('(Home page) Error in onResetFilters function:', error);
            //reportError(error); // Send error report to backend
        }
    }

    return (
        <Container>
            <Header />
            <MainContent>
                {withFilters ?
                        <Filters onApplyFilter={(el) => onApplyFilter(el)} onResetFilters={onResetFilters} filtersTranslate={filtersTranslate} language={i18next.resolvedLanguage} entitiesData={entitiesData} apiKey={apiKey} enableApply={enableApplyButton} /* defaultEntity={entitieToFetch} defaultSubEntity={subEntitieToFetch} */ />
                    : null
                }

                <RightContent>
                    {renderPage(currentPath)}
                    {!currentPath?.includes('/home/map') && !currentPath?.includes('home/analitics') ? <Footer /> : null}
                </RightContent>
            </MainContent>
        </Container>
    );
}